// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2O6fb","unreadBadge":"styles_unreadBadge__1AexQ","modalContent":"styles_modalContent__2yMw1","modal":"styles_modal__2eStt"};